// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
import Swal from "sweetalert2"
import "./controllers"

// Substitui o confirm() nativo: todo data-turbo-confirm vira um modal SweetAlert2.
// A função deve retornar uma Promise<boolean> — o Turbo só envia o form se for true.
Turbo.config.forms.confirm = (message) => {
  return Swal.fire({
    title: "Tem certeza?",
    text: message,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sim, continuar",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#dc2626",
    reverseButtons: true,
  }).then((result) => result.isConfirmed)
}
